import type { ProFeatureId } from "@/types/billing.types";

export type ProFeature = {
  id: ProFeatureId;
  title: string;
  description: string;
};

export const FREE_TIER_MAX_OWNED_STARTUPS = 1;

export const PRO_FEATURES: ProFeature[] = [
  {
    id: "multiple_startups",
    title: "Multiple startups",
    description: "Create and manage more than one burn chart on your account.",
  },
  {
    id: "ai_advisor",
    title: "AI financial advisor",
    description: "Ask questions grounded in your burn chart, runway, and projections.",
  },
  {
    id: "business_plan",
    title: "AI business plan",
    description: "Generate investor-ready plans from your model and founder drafts.",
  },
  {
    id: "api_access",
    title: "API access",
    description: "Programmatic access with API keys for integrations and automation.",
  },
];

export const PRO_PRICING = {
  monthlyUsd: 9.99,
  yearlyUsd: 99,
  /** Full price if billed monthly for 12 months */
  yearlyFullPriceUsd: 119.88,
  yearlySavingsUsd: 20.88,
  yearlyDiscountPercent: 17,
} as const;

export const PRO_SUBSCRIPTION_STATUSES = new Set(["active", "trialing"]);

export function isProSubscription(
  subscription?: { plan?: string; status?: string } | null,
): boolean {
  if (!subscription) return false;
  return (
    subscription.plan === "pro" &&
    PRO_SUBSCRIPTION_STATUSES.has(subscription.status ?? "")
  );
}
